<div class="w-full flex p-3! border border-gray-200 z-50">
  <p-button
    icon="pi pi-bars"
    [outlined]="true"
    size="large"
    class="md:hidden me-2"
    (onClick)="
      navBarService.isNavDrawerOpenMobile.set(
        !navBarService.isNavDrawerOpenMobile()
      )
    "
  ></p-button>

  <!-- logo -->
  <div class="flex items-center gap-2 md:ms-4">
    <div alt="logo" class="logo w-7 h-7 md:block hidden"></div>
    <p class="font-bold text-xl mb-0 text-afra-green">مدرسه مدیریتی افرا</p>
  </div>
  <div class="mr-auto ml-2 lg:ml-8 gap-2 flex">
    <!-- Notifications button with dropdown -->
    <div class="relative">
      @if (hasUnseenNotifMessageCount() > 0) {
      <p-overlaybadge severity="danger">
        <p-button
          icon="pi pi-bell text-xl!"
          size="large"
          styleClass=""
          [outlined]="true"
          (onClick)="toggleNotificationsDropdown($event)"
        ></p-button>
      </p-overlaybadge>
      } @else {
      <p-button
        icon="pi pi-bell text-xl!"
        size="large"
        styleClass="mr-2"
        [outlined]="true"
        (onClick)="toggleNotificationsDropdown($event)"
      ></p-button>
      }
      <!-- Notifications dropdown -->

      <p-popover #notificationsPopover>
        <ng-template pTemplate="content">
          <div class="">
            @if (notifications() && messages()) {
            <notificatoins-and-messages-dropdown
              [notifications]="notifications()"
              [messages]="messages()"
              (notificationsChange)="onNotificationsChange($event)"
              (messagesChange)="onMessagesChange($event)"
            ></notificatoins-and-messages-dropdown>
            }
          </div>
        </ng-template>
      </p-popover>
    </div>

    <div class="text-center text-lg-end me-md-5">
      <app-auth-bar></app-auth-bar>
    </div>
  </div>
</div>
